import React, { useState, useEffect, createRef } from "react";
import InView from "react-intersection-observer";
import ImageImpact from "../../images/po-impact-img.png";
import ImageImpactPattern from "../../images/po-impact-pattern.svg";

import ImageFutureAI1 from "../../images/future-ai-img-1.png";
import ImageFutureAI2 from "../../images/future-ai-img-2.png";
import ImageFutureAIPattern from "../../images/future-ai-pattern.svg";

import ImageReady from "../../images/ready-to-go-img.png";
import ImageReadyToGoPattern from "../../images/ready-to-pattern.svg";
import LazyLoad from 'react-lazyload';
import Parallax from '../common/utils/animations/parallax';
import { directions } from '../common/utils/animations/animationConstants';
//import AOS from 'aos';
import 'aos/dist/aos.css'
import lottie from 'lottie-web';
import animation from '../../icons/svg_animations/Path-Animation-impact/PathAnimationImpact.json';
import animation1 from '../../icons/svg_animations/Path-Animation-FutureAI/PathAnimationFutureAI.json';
import animation2 from '../../icons/svg_animations/Path-Animation-ReadyToGo/PathAnimationReadyToGo.json';

export default function Impact() {
    let animationContainer = createRef();
    let animationContainer1 = createRef();
    let animationContainer2 = createRef();
    const [counterTrigger, setCounterTrigger] = useState(false);
    let AOS;

    useEffect(() => {
        const AOS = require("aos");
        AOS.init({
        once: true,
        });

        const anim = lottie.loadAnimation({
            container: animationContainer.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: animation
          });

          const anim1 = lottie.loadAnimation({
            container: animationContainer1.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: animation1
          });

          const anim2 = lottie.loadAnimation({
            container: animationContainer2.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: animation2
          });
    }, []);

    useEffect(() => {
        if (AOS) {
        AOS.refresh();
        }
    });

  return (
    <div>
        <div className="section-gap po-impact">
            <div className="container">
                <div className="po-impact-inner row d-flex flex-wrap align-v-center">
                <div className="col po-impact-content">
                    <h3>The Impact</h3>
                    <p>In the first six months, the internet-enhanced home physical therapy platform has helped orthopedic surgeons, physical therapists, and athletic trainers to serve 2000+ patients and facilitated them to recover faster, and we received raving reviews from each patient. PhysioOutcomes is continuously rolling out this platform to clinics and therapists, and we continue to make it into the best connected care platform out there.</p>
                </div>
                <div className="col po-impact-image">
                    <div data-aos="zoom-in" data-aos-delay="200"><Parallax classes="po-impact-image1" id="po-impact-image1" direction={directions.BTT} triggers={[0.2, 1.2]} length={150}><LazyLoad offset={500}><img src={ImageImpact} title="Faster recovery time" alt="Faster recovery time" /></LazyLoad></Parallax></div>
                </div>
                </div>
            </div>
            <div className="po-impact-pattern">
                <div><div className="path-animation-impact-container" ref={animationContainer} /></div>
            </div>
        </div>
        <div className="section-gap-large po-future-ai">
            <div className="container">
            <div className="po-future-ai-inner row d-flex flex-wrap align-v-center">
                <div className="col po-future-ai-image">
                    <div data-aos="zoom-in" data-aos-delay="200"><Parallax classes="po-future-image1" id="po-future-image1" direction={directions.BTT} triggers={[0.2, 1.2]} length={50}><LazyLoad offset={500}><img src={ImageFutureAI1} title="Automated patient tracking" alt="Automated patient tracking" /></LazyLoad></Parallax></div>
                    <div data-aos="zoom-in" data-aos-delay="300"><Parallax classes="po-future-image2" id="po-future-image2" direction={directions.TTB} triggers={[1.2, 0.2]} length={50}><LazyLoad offset={500}><img src={ImageFutureAI2} title="Automated patient tracking" alt="Automated patient tracking" /></LazyLoad></Parallax></div>
                </div>
                <div className="col po-future-ai-content">
                    <h3>Artificial Intelligence – The future of rehab</h3>
                    <p>With PhysioOutcomes’ vision, we continue to push the limits of technology for helping patients and providers. We are integrating automated patient tracking using wearable tech and AI that can track body movement with extreme precision and provide a reliable assessment of the quality of movement and enable us to identify areas of MSK systems that may be weak and vulnerable to injuries for each patient. </p>

                    <p>We are super excited about the future and the potential that IoT, AI, and connected experiences bring to reimagine rehab!</p>
                    <InView as="div" onChange={(inView) => { if (inView) setCounterTrigger(inView); }} className="future-counter-block" threshold={[0.4]}>
                    <ul>
                        <li>
                            <h4 className="lovander-color">3,780</h4>
                            <p>Quaternion <br />Multiplications per <br />Second</p>
                        </li>
                        <li>
                            <h4 className="yellow-color">4,800</h4>
                            <p>Angles Calculated <br />per Second</p>
                        </li>
                        <li>
                            <h4 className="blue-color">9,600</h4>
                            <p>Angular Derivatives <br />Calculated per Second</p>
                        </li>
                    </ul>
                    </InView>
                </div>
                
            </div>
            </div>
            <div className="po-future-ai-pattern">
            <div><div className="path-animation-futureAI-container" ref={animationContainer1} /></div>
            </div>
        </div>

        <div className="cb-testimonial-section section-gap-large po-testimonial">
            <div className="container">
            <blockquote>
                <h6>
                Rapidops has enabled our patients to receive their care and stay connected with their providers anywhere and anytime from our outstanding mobile app.
                </h6>
                <div className="blockquote-author d-flex align-v-center">
                <div className="blockquote-detail">
                    <p>John Paul - Founder, PhysioOutcomes</p>
                </div>
                </div>
            </blockquote>
            </div>
      </div>

      <div className="section-gap ready-to-go-section">
            <div className="container">
                <div className="ready-to-go-inner row d-flex flex-wrap align-v-center">
                <div className="col ready-to-go-content">
                    <h3>Ready to go!</h3>
                    <p>We strongly believe that PhysioOutcomes has the potential to reshape patient education, physical therapy, and at-home engagement for good in this multi-billion industry. The automated and engaging experiences that the PhysioOutcomes platform enabled, has already helped thousands of patients heal faster with positive behaviors and reduced costs. PhysioOutcomes has also published multiple research papers that demonstrated the power of their approach in engaging patients during recovery. Now it is ready to conquer the world, and together we are constantly pushing the boundaries of MSK care for everyone.</p>
                </div>
                <div className="col ready-to-go-image">
                    <div data-aos="zoom-in" data-aos-delay="200"><Parallax classes="po-ready-image1" id="po-ready-image1" direction={directions.TTB} triggers={[1.2, 0.2]} length={50}><LazyLoad offset={500}><img src={ImageReady} title="PhysioOutcome Platform" alt="PhysioOutcome Platform" /></LazyLoad></Parallax></div>
                </div>
                </div>
            </div>
            <div className="ready-to-go-pattern">
                <div><div className="path-animation-readytogo-container" ref={animationContainer2} /></div>
            </div>
        </div>
  </div>
  );
}

